// @flow

import { postApi } from './api.core'

export const registerUKManager = credentials =>
  postApi('api/pmc_registration/', credentials)
